import React, { useState, useEffect } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import UserAccess from "../components/Auth/UserAccess";

const Admin = (props) => {
  console.log("User Access in Admin.js", UserAccess());
  console.log("PROPS inside Admin ", props);
  const mainContent = React.useRef(null);
  const location = useLocation();

  const [logo, setLogo] = useState(
    require("../assets/img/brand//adect-logo.png").default
  );

  useEffect(() => {
    const idenfityLogo = () => {
      if (process.env.REACT_APP_TENANT.includes("ADECT")) {
        setLogo(require("../assets/img/brand//adect-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("GCO")) {
        setLogo(require("../assets/img/brand//gco-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("APPSTORE")) {
        setLogo(require("../assets/img/brand//asqs-logo.png").default);
      }
    };
    idenfityLogo();
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/home",
          imgSrc: logo,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          data={[1, 2, 3]}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/home" />
          {/* <Redirect from="/associates/index" to="/associates/index" /> */}
          {/* <Redirect from="" to="" /> */}
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
